import React, { FC, MouseEventHandler } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import styles from './styles.module.scss'

type LoginButtonProps = {
  caption: string
  onClick?: MouseEventHandler<HTMLButtonElement>
  disabled?: boolean
  className?: string
}

const LoginButton: FC<LoginButtonProps> = ({
  caption,
  onClick,
  disabled,
  className
}) => {
  const { loginWithRedirect } = useAuth0()
  return (
    <button
      className={[styles.loginButton, className].join(' ')}
      data-testid="login-button"
      type="button"
      disabled={disabled}
      onClick={
        onClick ||
        (() =>
          loginWithRedirect({
            initial_screen: 'login'
          }))
      }
    >
      {caption}
    </button>
  )
}

export default LoginButton
